import * as React from 'react';
import { IContentElementProps } from '../utils/tracking/tracking.interfaces';

export const defaultElement: IContentElementProps = {
  elementName: null,
  elementType: null,
};

export const TrackingContext: React.Context<IContentElementProps> = React.createContext(
  defaultElement
);
